import { Outlet } from 'react-router-dom';
import Container from 'react-bootstrap/Container';

import { Navigation, UserInfoBar } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { SpecialAnnouncements } from '../components/SpecialAnnouncements';
import { LoginPanel, ResetPassPanel } from '../auth'

import './MainLayout.css';

export function MainLayout() {

    return (
        <main>
            <Navigation />
            <UserInfoBar />
            <SpecialAnnouncements />
            <Container className="main-content" fluid>
                <Container fluid="lg">
                    <Outlet />
                </Container>
            </Container>
            <Footer />

            <LoginPanel />
            <ResetPassPanel />
        </main>
    );
}

